<app-loading *ngIf="loading"></app-loading>

<div class="panel-header panel-header-sm">
    <div class="row link-header ml-5">
        <div><a class="a-home" routerLink="/home">Home/</a></div>
        <div><a class="a-return" routerLink="/reprint-invoice">Reimpresión Factura/</a></div>
        <div><a class="text-info">Reenviar XML a DNIT</a></div>
    </div>
</div>

<div class="main-content">

    <!-- INFO FACTURA -->
    <div class="row justify-content-center">
        <div class="col-md-10">
            <div class="card">
                <div class="card-header">
                    <h4 class="card-title">Reenviar XML a DNIT</h4>
                    <h6 class="category">Carga el XML corregido y envíalo directamente a DNIT</h6>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-4">
                            <label><b>Invoice Code</b></label>
                            <input type="text" class="form-control form-control-sm" [value]="invoiceCode" readonly />
                        </div>
                        <div class="col-md-3">
                            <label><b>Tipo DTE</b></label>
                            <select class="form-control form-control-sm" [value]="typeDTE"
                                (change)="typeDTE = $any($event.target).value">
                                <option value="FE">FE - Factura Electrónica</option>
                                <option value="NR">NR - Nota de Remisión</option>
                                <option value="NC">NC - Nota de Crédito</option>
                            </select>
                        </div>
                        <div class="col-md-5">
                            <label><b>CDC (de la factura)</b></label>
                            <input type="text" class="form-control form-control-sm" [value]="cdc" readonly />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- CARGA XML -->
    <div class="row justify-content-center">
        <div class="col-md-10">
            <div class="card">
                <div class="card-header">
                    <h4 class="card-title">Archivo XML</h4>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-12">
                            <span class="btn btn-block btn-round btn-file btn-info">
                                <span class="font-weight-bold">Seleccionar archivo XML</span>
                                <input type="file" #fileInput accept=".xml" (change)="onFileSelected($event)" />
                            </span>
                        </div>
                    </div>

                    <!-- CDC extraído del XML -->
                    <div class="row mt-3" *ngIf="cdcFromXml">
                        <div class="col-md-12">
                            <label><b>CDC detectado en el XML:</b></label>
                            <div class="alert alert-info py-2 mb-0">
                                <code>{{ cdcFromXml }}</code>
                            </div>
                        </div>
                    </div>

                    <!-- Vista previa del XML -->
                    <div class="row mt-3" *ngIf="xmlContent">
                        <div class="col-md-12">
                            <label><b>Contenido del XML:</b></label>                            
                            <pre class="xml-preview">{{ xmlContent }}</pre>
                        </div>
                    </div>

                    <!-- Acciones -->
                    <div class="row mt-3" *ngIf="xmlContent">
                        <div class="col-md-6">
                            <button class="btn btn-success btn-round w-100 font-weight-bold"
                                (click)="sendToDnit()" [disabled]="loading">
                                <i class="now-ui-icons arrows-1_share-66 mr-1"></i>
                                Enviar a DNIT
                            </button>
                        </div>
                        <div class="col-md-6">
                            <button class="btn btn-default btn-round w-100"
                                (click)="clearFile()" [disabled]="loading">
                                Limpiar
                            </button>
                        </div>
                    </div>

                    <!-- Link S3 resultado -->
                    <div class="row mt-3" *ngIf="signedUrl">
                        <div class="col-md-12">
                            <div class="alert alert-success">
                                <b>XML subido a S3:</b><br>
                                <a [href]="signedUrl" target="_blank" class="text-break">
                                    Descargar XML certificado
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
